"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkProfileSetting = exports.isProfileSetting = void 0;
const __1 = require("..");
function isProfileSetting(object) {
    return checkProfileSetting(object).fulfilled;
}
exports.isProfileSetting = isProfileSetting;
function checkProfileSetting(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return (0, __1.check)(object, (0, __1.hasObject)("sortOptions", (0, __1.hasChoice)("sortBy", [
        __1.SortByType.ALPHABETICAL,
        __1.SortByType.CREATION_DATE,
        __1.SortByType.ID_NUMBER,
        __1.SortByType.CREATION_DATE,
        __1.SortByType.ORDER_NUMBER,
        __1.SortByType.LAST_EDITED,
        __1.SortByType.LAST_OPENED,
    ]), (0, __1.hasChoice)("orderBy", [__1.OrderByType.ASC, __1.OrderByType.DESC])), (0, __1.hasChoice)("notificationStatus", [__1.NotificationStatusType.SHOW, __1.NotificationStatusType.HIDE]), (0, __1.hasMap)("mutedPushes", (0, __1.isRecord)((0, __1.hasArray)("identifiers", (0, __1.isString)()))).optional()).withOptions(options).explain();
}
exports.checkProfileSetting = checkProfileSetting;
//# sourceMappingURL=ProfileSetting.js.map